import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const isGameRoute = location.pathname === '/game';
  const isHomeRoute = location.pathname === '/';

  // For game route, include header and footer - let Game component handle full viewport
  if (isGameRoute) {
    return (
      <div className="min-h-screen md:h-screen md:overflow-hidden pb-16 md:pb-0 safe-area-inset">
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary focus:text-white focus:rounded-md focus:font-medium"
        >
          Skip to content
        </a>
        <Header />
        <main id="main-content" className="md:h-full md:flex md:flex-col">
          {children}
        </main>
        <Footer />
      </div>
    );
  }

  // For home route, don't add container padding but include footer
  if (isHomeRoute) {
    return (
      <div className="min-h-screen pb-16 safe-area-inset">
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary focus:text-white focus:rounded-md focus:font-medium"
        >
          Skip to content
        </a>
        <Header />
        <main id="main-content">
          {children}
        </main>
        <Footer />
      </div>
    );
  }

  // Standard layout for other routes
  return (
    <div className="min-h-screen bg-background pb-16 safe-area-inset">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary focus:text-white focus:rounded-md focus:font-medium"
      >
        Skip to content
      </a>
      <Header />
      <main id="main-content" className="container mx-auto px-4 py-8 max-w-7xl">
        {children}
      </main>
      <Footer />
    </div>
  );
}
